import { useMemo } from 'react';
import { useData } from 'context/data.context';
import ActivityCard from '../cards/activity.card';

const ActivityPanel = ({ onItemClick }) => {
  const { assets, liabilities } = useData();

  // Combine and sort by updated date (most recent first)
  const activityItems = useMemo(() => {
    const combined = [
      ...assets.map(item => ({ ...item, type: 'Assets' })),
      ...liabilities.map(item => ({ ...item, type: 'Liabilities' }))
    ];

    return combined.sort((a, b) => new Date(b.updated) - new Date(a.updated));
  }, [assets, liabilities]);

  return (
    <div className="Activity">
      <div className="flex col large-gap">
        <p className="xlarge padding">Recent Activity</p>

        <div className="flex col medium-gap">
          {activityItems.length === 0 ? (
            <div className="card">
              <p className="regular o60">No activity yet. Add some assets or liabilities to get started.</p>
            </div>
          ) : (
            activityItems.map((item) => (
              <ActivityCard
                key={item.id}
                item={item}
                onClick={() => onItemClick(item, item.type)}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityPanel;
